import { user, ThemeProps } from 'services/analytics/events';
import { setIdentity, resetIdentity } from 'services/analytics/track';
import { getAnalyticsClient } from 'services/apollo';
import { GetUserQuery } from 'services/apollo/queries';
import { trackInfo, infoMessage } from 'helpers';

export const trackingLogin = () => {
  const getDataForSettingIdentity = getAnalyticsClient().then((client) =>
    client.query({
      query: GetUserQuery,
      fetchPolicy: 'cache-first',
    })
  );
  getDataForSettingIdentity.then((response) => {
    const email = response.data.me.userProfile.email;
    const organizationName = response.data.me.userProfile.organization.name;
    setIdentity(email, organizationName);
    user.signin();
    trackInfo(infoMessage.Login);
  });
};

export const trackingLogout = () => {
  user.signout();
  return resetIdentity();
};

export const trackingTheme = (mode: string) => {
  const newTheme = mode === 'dark' ? 'light' : 'dark';
  const metadata: ThemeProps = {
    '[Metadata] Set Theme': newTheme,
  };
  return user.toggleTheme(metadata);
};
